"use strict";

require("intersection-observer");
var Scrollama = require("scrollama");
const Flickity = require("flickity");
const imagesLoaded = require("imagesloaded");
var Cookies = require("js-cookie");

const Global = require("./global.js");
const Pages = require("./pages.js");
const Videos = require("./videos.js");
const Components = require("./components.js");
const Gallery = require('./gallery.js');
const Lazy = require("./lazy.js");

let init = function() {
  $(document).ready(function() {
    window.videos = [];

    new Global();

    $(".vimeo-video").each(function() {
      new Videos.Vimeo(this);
    });
    $(".youtube-video").each(function() {
      new Videos.Youtube(this);
    });

    $(".accordion-section").each(function() {
      new Components.Accordion(this);
    });
    $(".list-section").each(function() {
      new Components.Lists(this);
    });
    $(".filter-dropdown").each(function() {
      new Components.Filter(this);
    });

    if ($(".work-page").length) {
      new Pages.Work();
    }
    if ($(".insights-page").length) {
      new Pages.Insights();
    }

    window.lazyLoad = new Lazy.LazyLoad([
      ".team-section .item",
      ".team-section .headline",
      ".list-section .item",
      ".pagnation-section .load-more",
      ".text-section",
      ".video-section .vimeo-video",
      // ".video-section .youtube-video",
      ".video-section .caption",
      ".side-by-side-images-section .left",
      ".side-by-side-images-section .right",
      ".share-menu",
      ".related-section",
      ".inline-gallery .gallery",
      ".inline-gallery .gallery-meta",
      ".infinite-scroll-status .infinite-scroll-request",
      ".insights-grid-row .contents",
      ".news-sidebar",
      ".blockquote-section .contents",
      ".home-page .featured-gallery .gallery-meta",
      ".site-filter-section"
    ]);

    // Initialize galleries
    $(".inline-gallery .gallery").each(function() {
      new Gallery.InlineGallery(this);
    });
    $(".fullscreen-gallery .gallery").each(function() {
      new Gallery.FullScreenGallery(this);
    });
    $(".featured-gallery .gallery").each(function() {
      new Gallery.FeaturedGallery(this);
    });
    $(".search-gallery .gallery").each(function() {
      new Gallery.SearchGallery(this);
    });
  });
};

init();